import { Box } from '../box';
import { Flex } from '../flex';
import { Text } from '../text';

export interface SectionTitleProps {
  title: string;
  endAdornment?: React.ReactNode;
}

export default function SectionTitle(props: Readonly<SectionTitleProps>) {
  const { title, endAdornment } = props;
  return (
    <Flex
      sx={(theme) => ({
        borderLeft: '4px solid',
        pl: theme.spacing(3),
        borderColor: theme.palette.primary.main,
        justifyContent: 'space-between',
        alignItems: 'center',
      })}
    >
      <Text variant='h4'>{title}</Text>
      <Box>{endAdornment}</Box>
    </Flex>
  );
}
